export const LastUpdated = '12 Mars 2026';
